import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import AdmissionEnquiryForm from '../components/common/AdmissionEnquiryForm';

const StandardHomePage = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);

  const openForm = () => setIsFormOpen(true);
  const closeForm = () => setIsFormOpen(false);

  const quickStats = [
    { number: '50+', label: 'Academic Programs' },
    { number: '5000+', label: 'Students' },
    { number: '200+', label: 'Faculty Members' },
    { number: '90%+', label: 'Placement Rate' }
  ];

  const featuredPrograms = [
    {
      title: 'Computer Science & Engineering',
      description: 'Cutting-edge curriculum in AI, Machine Learning, and Software Development',
      icon: 'fas fa-laptop-code',
      link: '/academics'
    },
    {
      title: 'Mechanical Engineering',
      description: 'Advanced manufacturing, robotics, and automotive engineering programs',
      icon: 'fas fa-cogs',
      link: '/academics'
    },
    {
      title: 'Electronics & Communication',
      description: 'Modern electronics, IoT, and communication systems technology',
      icon: 'fas fa-microchip',
      link: '/academics'
    },
    {
      title: 'Civil Engineering',
      description: 'Infrastructure development and sustainable construction practices',
      icon: 'fas fa-building',
      link: '/academics'
    }
  ];

  const newsUpdates = [
    {
      date: 'Dec 1, 2024',
      title: 'Admissions Open for Academic Year 2025-26',
      description: 'Apply now for undergraduate and postgraduate programs',
      link: '/admission'
    },
    {
      date: 'Nov 28, 2024',
      title: 'Research Excellence Award 2024',
      description: 'FiT Engineering College receives recognition for outstanding research contributions',
      link: '/research'
    },
    {
      date: 'Nov 25, 2024',
      title: 'Industry Partnership with Tech Giants',
      description: 'New collaboration agreements signed with leading technology companies',
      link: '/placements'
    }
  ];

  return (
    <div className="h-full w-full  fade-in">
      {/* Hero Section */}
      <section className="relative hero-bg-image bg-cover bg-center min-h-[500px] md:h-96 py-8 md:py-0">
        <div className="hero-overlay absolute inset-0"></div>
        
        <div className="relative z-10 h-full flex items-center">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 w-full">
            <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
              <div className="text-white text-center md:text-left">
                <h1 className="font-serif font-bold text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-tight mb-4 md:mb-6">
                  Welcome to<br />
                  <span className="text-gold">FiT Engineering College</span>
                </h1>
                <p className="text-base sm:text-lg md:text-xl mb-6 md:mb-8 opacity-90 leading-relaxed">
                  Shaping the future through excellence in engineering education, 
                  innovation, and research since our establishment.
                </p>
                <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center md:justify-start">
                  <button 
                    onClick={openForm}
                    className="bg-crimson hover:bg-red-800 text-white font-bold py-2.5 sm:py-3 px-6 sm:px-8 rounded-lg transition transform hover:-translate-y-1 shadow-lg text-sm sm:text-base"
                  >
                    Admission Enquiry
                  </button>
                  <Link 
                    to="/academics" 
                    className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-slate font-bold py-2.5 sm:py-3 px-6 sm:px-8 rounded-lg transition text-sm sm:text-base"
                  >
                    Academic Programs
                  </Link>
                </div>
              </div>
              
              {/* Announcements Card */}
              <div className="bg-white rounded-xl p-4 sm:p-6 shadow-float mx-auto max-w-sm md:max-w-none">
                <h3 className="font-serif font-bold text-2xl text-slate mb-4">Announcements</h3>
                <div className="h-64 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
                  <div className="space-y-3 pr-2">
                    <div className="p-3 bg-surface rounded-lg border-l-4 border-crimson">
                      <div className="flex items-start gap-3">
                        <i className="fas fa-bullhorn text-crimson mt-1"></i>
                        <div>
                          <h4 className="font-semibold text-slate text-sm">New Admission Notice 2025-26</h4>
                          <p className="text-xs text-gray-500 mt-1">Applications open for all engineering courses. Last date: 15th Dec 2024</p>
                          <span className="text-xs text-crimson">Dec 1, 2024</span>
                        </div>
                      </div>
                    </div>
                    
                    <div className="p-3 bg-surface rounded-lg border-l-4 border-blue-500">
                      <div className="flex items-start gap-3">
                        <i className="fas fa-file-alt text-blue-500 mt-1"></i>
                        <div>
                          <h4 className="font-semibold text-slate text-sm">Semester Examination Schedule</h4>
                          <p className="text-xs text-gray-500 mt-1">Winter semester exams to commence from 20th December 2024</p>
                          <span className="text-xs text-blue-500">Nov 28, 2024</span>
                        </div>
                      </div>
                    </div>
                    
                    <div className="p-3 bg-surface rounded-lg border-l-4 border-green-500">
                      <div className="flex items-start gap-3">
                        <i className="fas fa-calendar text-green-500 mt-1"></i>
                        <div>
                          <h4 className="font-semibold text-slate text-sm">Technical Fest 2024</h4>
                          <p className="text-xs text-gray-500 mt-1">Annual technical festival registration starts. Multiple events and competitions</p>
                          <span className="text-xs text-green-500">Nov 25, 2024</span>
                        </div>
                      </div>
                    </div>
                    
                    <div className="p-3 bg-surface rounded-lg border-l-4 border-orange-500">
                      <div className="flex items-start gap-3">
                        <i className="fas fa-award text-orange-500 mt-1"></i>
                        <div>
                          <h4 className="font-semibold text-slate text-sm">Scholarship Applications</h4>
                          <p className="text-xs text-gray-500 mt-1">Merit-based scholarship forms available. Apply before 10th December</p>
                          <span className="text-xs text-orange-500">Nov 22, 2024</span>
                        </div>
                      </div>
                    </div>
                    
                    <div className="p-3 bg-surface rounded-lg border-l-4 border-purple-500">
                      <div className="flex items-start gap-3">
                        <i className="fas fa-building text-purple-500 mt-1"></i>
                        <div>
                          <h4 className="font-semibold text-slate text-sm">Campus Placement Drive</h4>
                          <p className="text-xs text-gray-500 mt-1">Top companies visiting campus for final year placements. Register now</p>
                          <span className="text-xs text-purple-500">Nov 20, 2024</span>
                        </div>
                      </div>
                    </div>
                    
                    <div className="p-3 bg-surface rounded-lg border-l-4 border-red-500">
                      <div className="flex items-start gap-3">
                        <i className="fas fa-exclamation-triangle text-red-500 mt-1"></i>
                        <div>
                          <h4 className="font-semibold text-slate text-sm">Fee Payment Reminder</h4>
                          <p className="text-xs text-gray-500 mt-1">Last date for semester fee payment is 5th December 2024</p>
                          <span className="text-xs text-red-500">Nov 18, 2024</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mt-3 text-center">
                  <Link to="/announcements" className="text-crimson text-sm font-semibold hover:underline">
                    View All Announcements <i className="fas fa-arrow-right ml-1"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Quick Stats */}
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-8">
            {quickStats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-crimson mb-1 sm:mb-2">{stat.number}</div>
                <div className="text-xs sm:text-sm md:text-base text-gray-600 font-semibold">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Featured Programs */}
      <section className="py-12 sm:py-16 bg-surface">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-serif font-bold text-slate mb-3 sm:mb-4">Featured Programs</h2>
            <p className="text-sm sm:text-base text-gray-600 max-w-2xl mx-auto px-4 sm:px-0">
              Discover our industry-leading engineering programs designed to prepare you for tomorrow's challenges.
            </p>
          </div>
          
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 lg:gap-8">
            {featuredPrograms.map((program, index) => (
              <Link 
                key={index}
                to={program.link}
                className="bg-white p-6 rounded-xl border border-border_gray hover:shadow-card transition group"
              >
                <div className="w-16 h-16 bg-crimson rounded-lg flex items-center justify-center mb-4 group-hover:bg-red-800 transition">
                  <i className={`${program.icon} text-2xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold text-slate mb-3">{program.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{program.description}</p>
                <div className="mt-4 text-crimson font-semibold text-sm">
                  Learn More <i className="fas fa-arrow-right ml-1"></i>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose FIT */}
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
          <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
            <div>
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-serif font-bold text-slate mb-4 sm:mb-6 text-center md:text-left">Why Choose FiT Engineering College?</h2>
              <div className="space-y-6">
                
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-gold rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="fas fa-industry text-white"></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-slate mb-2">Industry Partnerships</h3>
                    <p className="text-gray-600">Strong ties with leading companies ensuring relevant curriculum and job opportunities.</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-gold rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="fas fa-flask text-white"></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-slate mb-2">Research Excellence</h3>
                    <p className="text-gray-600">State-of-the-art research facilities and opportunities for innovation.</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-gold rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="fas fa-users text-white"></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-slate mb-2">Expert Faculty</h3>
                    <p className="text-gray-600">Learn from experienced professors and industry professionals.</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="bg-gray-100 p-6 sm:p-8 rounded-xl h-64 sm:h-80 md:h-96 flex items-center justify-center order-first md:order-last">
              <div className="text-center text-gray-500">
                <i className="fas fa-camera text-6xl mb-4"></i>
                <p className="text-lg font-medium">Campus Virtual Tour</p>
                <p className="text-sm">Experience our world-class facilities</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Quick Links */}
      <section className="py-12 sm:py-16 bg-surface">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
          <div className="grid md:grid-cols-1 gap-8 md:gap-12">
            <div>
              <h2 className="text-2xl sm:text-3xl font-serif font-bold text-slate mb-6 sm:mb-8">Important Links</h2>
              <div className="grid gap-4">
                <Link 
                  to="/academics" 
                  className="bg-white p-4 rounded-lg border border-border_gray hover:shadow-card transition flex items-center gap-3"
                >
                  <i className="fas fa-calendar-alt text-crimson"></i>
                  <div>
                    <h4 className="font-semibold text-slate">Academic Calendar</h4>
                    <p className="text-sm text-gray-500">Important dates and schedules</p>
                  </div>
                </Link>
                
                <a 
                  href="https://aktu.ac.in" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-white p-4 rounded-lg border border-border_gray hover:shadow-card transition flex items-center gap-3"
                >
                  <i className="fas fa-university text-crimson"></i>
                  <div>
                    <h4 className="font-semibold text-slate">AKTU Website</h4>
                    <p className="text-sm text-gray-500">Dr. A.P.J. Abdul Kalam Technical University</p>
                  </div>
                  <i className="fas fa-external-link-alt text-gray-400 ml-auto"></i>
                </a>
                
                <a 
                  href="https://bteup.ac.in" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-white p-4 rounded-lg border border-border_gray hover:shadow-card transition flex items-center gap-3"
                >
                  <i className="fas fa-tools text-crimson"></i>
                  <div>
                    <h4 className="font-semibold text-slate">BTE Website</h4>
                    <p className="text-sm text-gray-500">Board of Technical Education, UP</p>
                  </div>
                  <i className="fas fa-external-link-alt text-gray-400 ml-auto"></i>
                </a>
                
                <Link 
                  to="/academics" 
                  className="bg-white p-4 rounded-lg border border-border_gray hover:shadow-card transition flex items-center gap-3"
                >
                  <i className="fas fa-book text-crimson"></i>
                  <div>
                    <h4 className="font-semibold text-slate">Syllabus & Curriculum</h4>
                    <p className="text-sm text-gray-500">Course structures and syllabi</p>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-12 sm:py-16 bg-slate text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 text-center">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-serif font-bold mb-4 sm:mb-6">Ready to Start Your Journey?</h2>
          <p className="text-base sm:text-lg md:text-xl mb-6 sm:mb-8 opacity-90 max-w-2xl mx-auto px-4 sm:px-0">
            Join thousands of successful graduates who started their careers at FiT Engineering College. 
            Your future begins here.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
            <button 
              onClick={openForm}
              className="bg-crimson hover:bg-red-800 text-white font-bold py-3 sm:py-4 px-6 sm:px-8 rounded-lg transition transform hover:-translate-y-1 shadow-lg text-sm sm:text-base"
            >
              Admission Enquiry
            </button>
            <Link 
              to="/about" 
              className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-slate font-bold py-3 sm:py-4 px-6 sm:px-8 rounded-lg transition text-sm sm:text-base"
            >
              Learn More About Us
            </Link>
          </div>
        </div>
      </section>

      <AdmissionEnquiryForm isOpen={isFormOpen} onClose={closeForm} />
    </div>
  );
};

export default StandardHomePage;